"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OFFLINE_CONFIG_FOLDER = void 0;
var OfflineConfigFolder_1 = require("./OfflineConfigFolder");
Object.defineProperty(exports, "OFFLINE_CONFIG_FOLDER", { enumerable: true, get: function () { return __importDefault(OfflineConfigFolder_1).default; } });
